import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export enum HeaderStateEnum {
  synced = 'synced',
  deleted = 'deleted',
  pending = 'pending',
}

export const HEADER_SCHEMA = Object.freeze({
  TYPE: '',
  SCHEMA_VERSION: '',
  ORIGINAL_SCHEMA_VERSION: '',
  PREFERRED_SCHEMA_VERSION: '',
  ACCOUNT_ID: '',
  CREATED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  UPDATED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  STATE: '',
});
const RECORD = generateSchema(HEADER_SCHEMA);
const KEYS: any = generateKeys(HEADER_SCHEMA);

export class Header extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get updatedDate(): string {
    return this.get(KEYS.UPDATED_DATE);
  }

  get state(): string {
    return this.get(KEYS.STATE);
  }

  isSynced(): boolean {
    return this.state === HeaderStateEnum.synced;
  }

  isDeleted(): boolean {
    return this.state === HeaderStateEnum.deleted;
  }

  isPending(): boolean {
    return this.state === HeaderStateEnum.pending;
  }
}
